import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog.tsx";
import { Button } from "@/components/ui/button.tsx";
import { useUser } from "@/hooks/useUser.ts";
import { setAuthCookie } from "@/lib/utils.ts";
import { useTranslation } from "@/i18n";

const SwitchAccountDialogContent = ({ onClose }: { onClose: () => void }) => {
  const user = useUser();
  const { t } = useTranslation();
  return (
    <DialogContent className="sm:max-w-[425px]">
      <DialogHeader>
        <DialogTitle>{t("switchClient.title")}</DialogTitle>
        <DialogDescription>{t("switchClient.description")}</DialogDescription>
      </DialogHeader>
      <div className="flex flex-col gap-4 py-4">
        {user!.clients.map((client) => (
          <Button
            key={client.name}
            variant="outline"
            onClick={() => {
              if (client.name === user!.client_name) {
                onClose();
                return;
              }
              setAuthCookie();
              window.location.assign(
                `https://${client.subdomain}.${client.landing_domain}`,
              );
            }}
            className="flex w-full justify-between p-2"
            size="content"
          >
            <img
              className="h-16 max-w-32"
              src={client.logo_url}
              alt={client.name}
            />
            <span className="whitespace-break-spaces">{client.name}</span>
          </Button>
        ))}
      </div>
    </DialogContent>
  );
};

export default SwitchAccountDialogContent;
